import { useEffect, useState } from "react";
import styles from "./bookingDetailsPopup.module.css";
import dayjs from "dayjs";
import axios from "axios";
import { Link } from "react-router-dom";
import { EditOutlined, PrintOutlined, PhoneOutlined, EmailOutlined } from "@mui/icons-material";
import download from "downloadjs";
import { authData } from "../../../../admin/components/GetAuth";
import Loader from "../../../../admin/components/Loader";
import HoverZoomImage from "../../../../admin/components/HoverZoomImage";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
const getItemStatusInfo = (item, bookingStatusText) => {
  if (parseInt(item?.is_deliverred) === 1) {
    return { label: item?.status_text || "Delivered", className: styles.ItemStatusDelivered };
  }
  if (parseInt(item?.is_out_for_delivery) === 1) {
    return { label: item?.status_text || "Out For Delivery", className: styles.ItemStatusTransit };
  }
  if (parseInt(item?.is_ship_received) === 1) {
    return { label: item?.status_text || "Received", className: styles.ItemStatusReceived };
  }
  if (parseInt(item?.is_port_received) === 1) {
    return { label: item?.status_text || "Received At Port", className: styles.ItemStatusTransit };
  }
  return { label: item?.status_text || bookingStatusText || "-", className: styles.ItemStatusPending };
};

export default function BookingDetailsPopup({ bookingId }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [bookingData, setBookingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pickupPhones, setPickupPhones] = useState([]);
  const [receipientPhones, setReceipientPhones] = useState([]);

  useEffect(() => {
    const getDetails = () => {
      setLoading(true);
      axios(process.env.REACT_APP_API_URL + "v1/customer/booking-full/" + bookingId, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        },
      })
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            setLoading(false);
            let bookingDataTemp = response.data.data;
            setBookingData(bookingDataTemp);

            if (bookingDataTemp && bookingDataTemp?.pickup_details?.phone) {
              let pPhones = [];

              if (bookingDataTemp?.pickup_details?.alt_phones && bookingDataTemp?.pickup_details?.alt_phones?.length > 0) {
                pPhones = bookingDataTemp?.pickup_details?.alt_phones?.map((i) => i);
              }

              setPickupPhones([bookingDataTemp?.pickup_details?.phone].concat(pPhones));
            }

            if (bookingDataTemp && bookingDataTemp?.recipient_details?.phone) {
              let pPhones = [];

              if (bookingDataTemp?.recipient_details?.alt_phones && bookingDataTemp?.recipient_details?.alt_phones?.length > 0) {
                pPhones = bookingDataTemp?.recipient_details?.alt_phones?.map((i) => i);
              }

              setReceipientPhones([bookingDataTemp?.recipient_details?.phone].concat(pPhones));
            }
          } else {
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    };
    getDetails();
  }, [API_TOKEN, bookingId]);

  const printBooking = (id) => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/customer/booking-pdf/" + id, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    })
      .then((response) => {
        setLoading(false);
        const content = response.headers["content-type"];
        download(response.data, "booking-" + id + ".pdf", content);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const isCancelled = bookingData?.status === -1 || bookingData?.status === "-1";
  const canEdit =
    (auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf("bookings:update") > -1) &&
    (bookingData?.status === 0 || bookingData?.status === "0" || bookingData?.status === 1 || bookingData?.status === "1");

  const deliveryDriverNames = Array.from(
    new Set((bookingData?.products || []).map((p) => p?.delivery_driver?.name).filter(Boolean))
  );

  return (
    <div className={styles.Wrap}>
      <Loader open={loading} setOpen={setLoading} />

      <div className={styles.BodyHWithIcon}>
        <p>#{bookingData?.booking_id} · full order manifest</p>
        <div className={styles.BodyHeadIcon}>
          {canEdit && (
            <Link to={"/booking/edit-booking/" + bookingData?.id} aria-label="Edit booking">
              <EditOutlined fontSize="small" />
            </Link>
          )}
          <button onClick={() => printBooking(bookingData?.id)} aria-label="Print booking">
            <PrintOutlined fontSize="small" />
          </button>
        </div>
      </div>

      <div className={styles.MondalBodyDeRow}>
        <div className={styles.ModalDeBigSec}>
          <p className={styles.StepBoxTitle2}>Customer account details</p>
          <ul className={styles.SummeryListSec}>
            <li>
              <p className={styles.SummeryHeadTitle}>Customer ID</p>
              <p className={styles.SummeryHeadText}>{bookingData?.customer?.customer_id}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Name</p>
              <p className={styles.SummeryHeadText}>{bookingData?.customer?.name}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Mobile</p>
              <p className={styles.SummeryHeadText}>{bookingData?.customer?.phone}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Email</p>
              <p className={styles.SummeryHeadText}>{bookingData?.customer?.email}</p>
            </li>
          </ul>
        </div>

        <div className={styles.ModalDeBigSec}>
          <p className={styles.StepBoxTitle2}>Additional info</p>
          <ul className={styles.SummeryListSec}>
            <li>
              <p className={styles.SummeryHeadTitle}>Taken by</p>
              <p className={styles.SummeryHeadText}>{bookingData?.created_user}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Last edited by</p>
              <p className={styles.SummeryHeadText}>{bookingData?.edited_user}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Container</p>
              <p className={styles.SummeryHeadText}>-</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Items</p>
              <p className={styles.SummeryHeadText}>{bookingData?.no_of_items} item(s)</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Freight option</p>
              <p className={`${styles.SummeryHeadText} ${styles.FreightTag}`}>
                {bookingData?.freight_type === 'Air Freight' ? <FlightTakeoffIcon /> : <DirectionsBoatIcon />}
                {bookingData?.freight_type || 'Sea Freight'}
              </p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Picked by</p>
              <p className={styles.SummeryHeadText}>{bookingData?.picked_driver?.name}</p>
            </li>
            <li>
              <p className={styles.SummeryHeadTitle}>Delivered by</p>
              <p className={styles.SummeryHeadText}>
                {deliveryDriverNames.length === 0 && "-"}
                {deliveryDriverNames.length === 1 && deliveryDriverNames[0]}
                {deliveryDriverNames.length > 1 && deliveryDriverNames.join(", ")}
              </p>
            </li>
          </ul>
        </div>
      </div>

      {bookingData?.images?.length > 0 && (
        <div className={styles.MondalBodyDeRow}>
          <div className={styles.ModalDeFullSec}>
            <p className={styles.StepBoxTitle2}>Pickup photo(s)</p>
            <div className={styles.ImageRow}>
              {bookingData?.images?.map((img, index) => (
                <HoverZoomImage key={img.id || index} src={img.image_url} alt="Pickup photo" className={styles.imgDiv} />
              ))}
            </div>
          </div>
        </div>
      )}

      <div className={styles.MondalBodyDeRow}>
        <div className={styles.ModalDeBigSec}>
          <p className={styles.Title}>Booking note</p>
          <p className={styles.Text}>{bookingData?.description || "—"}</p>
        </div>
      </div>

      {isCancelled && (
        <div className={styles.BookingNote}>
          <p className={styles.Title}>Cancel note</p>
          <p className={styles.Text}>{bookingData?.cancel_note || "—"}</p>
        </div>
      )}

      <div className={styles.MondalBodyDeRow2}>
        <p className={styles.FullTitle}>Collection and delivery details</p>
        <div className={styles.MondalBodyDeRow} style={{ marginBottom: 0 }}>
          <div className={styles.ModalDeBigSec}>
            <p className={styles.StepBoxTitle2}>Pickup address</p>
            <p className={styles.PickName}>{bookingData?.pickup_details?.name}</p>
            <p className={styles.DetailsList}>{bookingData?.pickup_details?.address}</p>
            {bookingData?.pickup_details?.post_code && <p className={styles.DetailsList}>Post code: {bookingData?.pickup_details?.post_code}</p>}
            <p className={styles.DetailsList}>
              <EmailOutlined /> {bookingData?.pickup_details?.email}
            </p>
            <p className={styles.DetailsList}>
              <PhoneOutlined /> {pickupPhones.join(", ")}
            </p>
          </div>
          <div className={styles.ModalDeBigSec}>
            <p className={styles.StepBoxTitle2}>Delivery address</p>
            <p className={styles.PickName}>{bookingData?.recipient_details?.name}</p>
            <p className={styles.DetailsList}>{bookingData?.recipient_details?.address}</p>
            {bookingData?.recipient_details?.post_code && <p className={styles.DetailsList}>Post code: {bookingData?.recipient_details?.post_code}</p>}
            {bookingData?.recipient_details?.email && bookingData?.recipient_details?.email !== "" && (
              <p className={styles.DetailsList}>
                <EmailOutlined /> {bookingData?.recipient_details?.email}
              </p>
            )}
            <p className={styles.DetailsList}>
              <PhoneOutlined /> {receipientPhones.join(", ")}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.MondalBodyDeRow2}>
        <p className={styles.FullTitle}>Item details</p>
        <div className={styles.ModalDeFullSec}>
          <p className={styles.StepBoxTitle2}>Pickup date: {dayjs(bookingData?.pickup_date).format("ddd MMM D, YYYY")}</p>
          <div className={styles.TableSec}>
            <table>
              <tbody>
                <tr>
                  <td className={`${styles.TableHead} ${styles.TableHeadItems}`}>Item ID</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadItems}`}>Item</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadItems}`}>Cost</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadItems}`}>Status</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadItems}`}>Container</td>
                </tr>
                {bookingData?.products?.map((item, index) => {
                  const itemStatus = getItemStatusInfo(item, bookingData?.status_text);
                  return (
                    <tr key={item.item_id || index}>
                      <td className={styles.TableCon}>{item.item_id}</td>
                      <td className={styles.TableCon}>
                        {item.product_title}
                        {parseInt(item.is_dimension) === 1 && (
                          <>
                            <br />
                            <span style={{ fontSize: "11px" }}>
                              Dimension: <strong>L:{item?.length}cm</strong> <strong>W:{item?.width}cm</strong> <strong>H:{item?.height}cm</strong>
                            </span>
                          </>
                        )}
                        {bookingData?.freight_type === 'Air Freight' && item?.weight && (
                          <>
                            <br />
                            <span style={{ fontSize: "11px" }}>Weight: <strong>{item.weight} kg</strong></span>
                          </>
                        )}
                      </td>
                      <td className={styles.TableCon}>
                        £{parseFloat(item.subtotal).toFixed(2)}
                        {parseFloat(item.discount) > 0 && (
                          <>
                            <br />
                            <span style={{ fontSize: "11px" }}>(-£{parseFloat(item.discount).toFixed(2)})</span>
                          </>
                        )}
                      </td>
                      <td className={styles.TableCon}>
                        <span className={`${styles.ItemStatusBadge} ${itemStatus.className}`}>{itemStatus.label}</span>
                        {parseInt(item?.is_deliverred) === 1 && item?.delivered_date && (
                          <span className={styles.ItemStatusDate}>{dayjs(item.delivered_date).format("DD MMM YYYY")}</span>
                        )}
                      </td>
                      <td className={styles.TableCon}>{item?.container_name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className={styles.EstiAmmo}>
            <ul>
              <li>
                <p className={styles.EstiTitle}>Item subtotal</p>
                <p className={styles.EstiInput}>£{parseFloat(bookingData?.amount)?.toFixed(2)}</p>
              </li>
              {bookingData?.discount_amount > 0 && bookingData?.discount_val > 0 && (
                <li>
                  <p className={styles.EstiTitle}>Membership discount ({bookingData?.discount_val}%)</p>
                  <p className={styles.EstiInput}>-£{parseFloat(bookingData?.discount_amount)?.toFixed(2)}</p>
                </li>
              )}
              {bookingData?.referral_discount > 0 && (
                <li>
                  <p className={styles.EstiTitle}>Referral discount</p>
                  <p className={styles.EstiInput}>-£{parseFloat(bookingData?.referral_discount)?.toFixed(2)}</p>
                </li>
              )}
              {(bookingData?.collection_charge > 0 || bookingData?.delivery_charge > 0) && (
                <li>
                  <p className={styles.EstiTitle}>Item total</p>
                  <p className={styles.EstiInput}>£{Math.max(0, parseFloat(bookingData?.amount || 0) - parseFloat(bookingData?.discount_amount || 0) - parseFloat(bookingData?.referral_discount || 0)).toFixed(2)}</p>
                </li>
              )}
              {bookingData?.collection_charge > 0 && (
                <li>
                  <p className={styles.EstiTitle}>Collection charge{bookingData?.collection_miles ? ` (${parseFloat(bookingData.collection_miles).toFixed(2)} mi)` : ""}</p>
                  <p className={styles.EstiInput}>£{parseFloat(bookingData?.collection_charge).toFixed(2)}</p>
                </li>
              )}
              {bookingData?.delivery_charge > 0 && (
                <li>
                  <p className={styles.EstiTitle}>Delivery charge{bookingData?.delivery_miles ? ` (${parseFloat(bookingData.delivery_miles).toFixed(2)} mi)` : ""}</p>
                  <p className={styles.EstiInput}>£{parseFloat(bookingData?.delivery_charge).toFixed(2)}</p>
                </li>
              )}
              <li>
                <p className={styles.EstiTitle}>Total VAT</p>
                <p className={styles.EstiInput}>£0.00</p>
              </li>
              <li>
                <p className={styles.EstiTitle}>Insurance charges</p>
                <p className={styles.EstiInput}>£0.00</p>
              </li>
              <li>
                <p className={styles.EstiTitle}>Order total</p>
                <p className={styles.EstiInput}>£{parseFloat(bookingData?.total)?.toFixed(2)}</p>
              </li>
            </ul>
          </div>        </div>
      </div>

      <div className={styles.MondalBodyDeRow2}>
        <p className={styles.FullTitle}>Delivery groups</p>
        <div className={styles.ModalDeFullSec}>
          {(!bookingData?.delivery_completions || bookingData.delivery_completions.length === 0) && (
            <p className={styles.Text}>No deliveries recorded yet.</p>
          )}

          {bookingData?.delivery_completions?.map((group) => (
            <div className={styles.DeliveryGroup} key={group.id}>
              <div className={styles.DeliveryGroupHead}>
                <div>
                  <p className={styles.DeliveryGroupDriver}>{group.driver?.name || "Unknown driver"}</p>
                  <p className={styles.DeliveryGroupDate}>{dayjs(group.delivered_date).format("ddd MMM D, YYYY")}</p>
                </div>
                <span className={styles.DeliveryGroupCount}>{group.items?.length || 0} item{(group.items?.length || 0) !== 1 ? "s" : ""}</span>
              </div>

              {group.items?.length > 0 && (
                <ul className={styles.DeliveryGroupItems}>
                  {group.items.map((item) => (
                    <li key={item.id}>{item.product_title || item.item_id}</li>
                  ))}
                </ul>
              )}

              {group.delivery_note && (
                <div className={styles.DeliveryGroupNote}>
                  <p className={styles.Title}>Delivery note</p>
                  <p className={styles.Text}>{group.delivery_note}</p>
                </div>
              )}

              {/* Proof of delivery: the photo beside the signature */}
              {(group.delivery_image_url || group.customer_signature_url) && (
                <div className={styles.ProofRow}>
                  <div>
                    <p className={styles.Title}>Delivery photo</p>
                    {group.delivery_image_url
                      ? <HoverZoomImage src={group.delivery_image_url} alt={`Delivery photo from ${group.delivered_date}`} className={styles.ProofBox} />
                      : <div className={`${styles.ProofBox} ${styles.ProofEmpty}`}>No photo</div>}
                  </div>
                  <div>
                    <p className={styles.Title}>Signature</p>
                    {group.customer_signature_url
                      ? <HoverZoomImage src={group.customer_signature_url} alt={`Signature captured on ${group.delivered_date}`} className={`${styles.ProofBox} ${styles.ProofSignature}`} contain />
                      : <div className={`${styles.ProofBox} ${styles.ProofEmpty}`}>Not signed</div>}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {bookingData?.payments?.length > 0 && (
        <div className={styles.MondalBodyDeRow2}>
          <p className={styles.FullTitle}>Payment details</p>
          <div className={styles.ModalDeFullSec}>
            <div className={styles.TableSec}>
              <table>
                <tbody>
                  <tr>
                    <td className={`${styles.TableHead} ${styles.TableHeadPayments}`}>Paid amount</td>
                    <td className={`${styles.TableHead} ${styles.TableHeadPayments}`}>Payment notes</td>
                    <td className={`${styles.TableHead} ${styles.TableHeadPayments}`}>Created by</td>
                    <td className={`${styles.TableHead} ${styles.TableHeadPayments}`}>Created date</td>
                  </tr>
                  {bookingData?.payments?.map((item, index) => (
                    <tr key={index}>
                      <td className={styles.TableCon}>£{parseFloat(item.amount).toFixed(2)}</td>
                      <td className={styles.TableCon}>{item.note}</td>
                      <td className={styles.TableCon}>{item.name}</td>
                      <td className={styles.TableCon}>{dayjs(item.created_at).format("DD/MM/YYYY LT")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}